export interface Hint {
  key: string
  image_url?: string
  hasGoodExample?: boolean
  hasBadExample?: boolean
  hasNeutralExample?: boolean
}

export const hints: Hint[] = [
  {
    key: 'realTimeDevelopment',
    image_url: 'https://images.unsplash.com/photo-1629194891750-cd24c0b9596f?q=80&w=1625&auto=format&fit=crop'
  },
  {
    key: 'instantDeploy',
    image_url: 'https://images.unsplash.com/photo-1581084158167-c9578e5e858e?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'usageBasedPricing',
    image_url: 'https://images.unsplash.com/photo-1591019423456-56262f86eda5?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'templates',
    image_url: 'https://images.unsplash.com/photo-1549241520-425e3dfc01cb?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'allInOnePlatform',
    image_url: 'https://images.unsplash.com/photo-1629196203697-19badac2fcda?q=80&w=2014&auto=format&fit=crop'
  },
  {
    key: 'backendFrontend',
    image_url: 'https://images.unsplash.com/photo-1554668048-5055c5654bbc?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'noVendorSprawl',
    image_url: 'https://images.unsplash.com/photo-1629194891750-cd24c0b9596f?q=80&w=1625&auto=format&fit=crop'
  },
  {
    key: 'thousandsOfIntegrations',
    image_url: 'https://images.unsplash.com/photo-1697985007857-0e0dd1f9ba3e?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'designViaUrl',
    image_url: 'https://images.unsplash.com/photo-1721156009362-006fb0a9466b?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'uiThemes',
    image_url: 'https://images.unsplash.com/photo-1587647454951-04a835b2a7ae?q=80&w=1015&auto=format&fit=crop'
  },
  {
    key: 'uiElementSelector',
    image_url: 'https://images.unsplash.com/photo-1628882471610-db33a9d5d068?q=80&w=1011&auto=format&fit=crop'
  },
  {
    key: 'responsiveUi',
    image_url: 'https://images.unsplash.com/photo-1628192302770-8fb3c687141a?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'enterpriseGrade',
    image_url: 'https://images.unsplash.com/photo-1629194891750-cd24c0b9596f?q=80&w=1625&auto=format&fit=crop'
  },
  {
    key: 'sandboxVsLive',
    image_url: 'https://images.unsplash.com/photo-1632442752220-36b1b7ccf684?q=80&w=1011&auto=format&fit=crop'
  },
  {
    key: 'builtInBackups',
    image_url: 'https://images.unsplash.com/photo-1628130298757-eea141a85719?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'customDomains',
    image_url: 'https://images.unsplash.com/photo-1571607023618-c93917452ed3?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'aiSoftwareEngineers',
    image_url: 'https://images.unsplash.com/photo-1628192302761-54951f469cba?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'aiBrowserTesting',
    image_url: 'https://images.unsplash.com/photo-1580508271385-40f3683cf893?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'autoGeneratedSpec',
    image_url: 'https://images.unsplash.com/photo-1595878744852-96a5ea1db51c?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'builtInVersionControl',
    image_url: 'https://images.unsplash.com/photo-1642414198314-37552b7e0f51?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'agentVsDiscussMode',
    image_url: 'https://images.unsplash.com/photo-1577915308850-7789b29ba2bc?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'transferPrototypes',
    image_url: 'https://images.unsplash.com/photo-1579792742297-c7571b17195f?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'assetsAndKnowledgeBase',
    image_url: 'https://images.unsplash.com/photo-1615749413727-825b59a857b5?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'easyToUseOtherServices',
    image_url: 'https://images.unsplash.com/photo-1575573550252-4bea31b9d485?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'aiFeaturesBuiltIn',
    image_url: 'https://images.unsplash.com/photo-1564951415682-4466397f7707?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'communityOnDiscord',
    image_url: 'https://images.unsplash.com/photo-1588097281266-310cead47879?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'discussMode',
    hasNeutralExample: true,
    image_url: 'https://images.unsplash.com/photo-1627844570809-afbbb6028fcd?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'explainUserExperience',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1597556926167-0660bad50e39?q=80&w=1624&auto=format&fit=crop'
  },
  {
    key: 'beExplicitAboutLocation',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1632687218777-92fea96fb3aa?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'giveFullContext',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1641852536275-e8723da8bcf1?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'askToUseApp',
    hasGoodExample: true,
    image_url: 'https://images.unsplash.com/photo-1638043008124-9268465173b7?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'copyPasteErrors',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1641852536275-e8723da8bcf1?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'useReferenceExamples',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1574968723999-6e4ba8224fcf?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'includeEdgeCases',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1590508998578-edf8da904c25?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'specifyDataAndContent',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1612416364684-c54c957d2b7e?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'afterTriesBreakDown',
    hasNeutralExample: true,
    image_url: 'https://images.unsplash.com/photo-1623067072691-be0bd03146f1?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'provideVisualDescriptions',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1633507631981-5b1684692890?q=80&w=2054&auto=format&fit=crop'
  },
  {
    key: 'defineUserRolesPermissions',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1528459639788-428ce548b1fb?q=80&w=1617&auto=format&fit=crop'
  },
  {
    key: 'startSmallEnhance',
    hasNeutralExample: true,
    image_url: 'https://images.unsplash.com/photo-1607499457689-3fd1ac3ffcdd?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'referenceYourOwnApp',
    hasNeutralExample: true,
    image_url: 'https://images.unsplash.com/photo-1625818372201-fb0ac24e5cee?q=80&w=987&auto=format&fit=crop'
  },
  {
    key: 'testAndIterateOutLoud',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1612539876631-a39b38cb9da9?q=80&w=2070&auto=format&fit=crop'
  },
  {
    key: 'askForAlternatives',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1661027916230-d98103cfc046?q=80&w=2074&auto=format&fit=crop'
  },
  {
    key: 'useYourOwnWords',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1629654858857-615c2c8be8a8?q=80&w=2094&auto=format&fit=crop'
  },
  {
    key: 'buildIncrementalSteps',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1629194893765-3a904e9080dd?q=80&w=2038&auto=format&fit=crop'
  },
  {
    key: 'explainThePurpose',
    hasGoodExample: true,
    hasBadExample: true,
    image_url: 'https://images.unsplash.com/photo-1629196198570-0a7c1194d999?q=80&w=2010&auto=format&fit=crop'
  },
  {
    key: 'describeHowUsed',
    hasNeutralExample: true,
    image_url: 'https://images.unsplash.com/photo-1628883229653-9bfa32a3efaa?q=80&w=1020&auto=format&fit=crop'
  },
  {
    key: 'provideBusinessRequirements',
    hasNeutralExample: true,
    image_url: 'https://images.unsplash.com/photo-1660992239349-2ec29089cd23?q=80&w=2010&auto=format&fit=crop'
  }
]
